"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCardiopulmonaryStressTest = createCardiopulmonaryStressTest;
const events_1 = require("../../../events");
const cardiopulmonaryStressTest_1 = require("../../../forms/htx/current-cardiological-state/cardiopulmonaryStressTest");
const queries_1 = require("../queries");
const messages = {
    cardiopulmonaryStressTest: {
        id: "dashboard.cardiopulmonary_stress_test",
        defaultMessage: "Spiroergometria"
    },
    notAbleToSpiroergometry: {
        id: "dashboard.not_able_to_spiroergometry",
        defaultMessage: "Nem alkalmas"
    },
    vo2: {
        id: "dashboard.vo2",
        defaultMessage: "{vo2} ml/kg/min"
    }
};
const cardiopulmonaryStressTestAchievedMaxCapacityMessages = {
    [cardiopulmonaryStressTest_1.AchievedMaxCapacity.YES]: {
        id: "dashboard.cardiopulmonary_stress_test.achieved_max_capacity.yes",
        defaultMessage: "Maximális terhelés mellett"
    },
    [cardiopulmonaryStressTest_1.AchievedMaxCapacity.NO]: {
        id: "dashboard.cardiopulmonary_stress_test.achieved_max_capacity.no",
        defaultMessage: "Submaximális terhelés mellett"
    }
};
const cardiopulmonaryStressTestBetaBlockerMessages = {
    [cardiopulmonaryStressTest_1.BetaBlocker.YES]: {
        id: "dashboard.cardiopulmonary_stress_test.beta_blocker.yes",
        defaultMessage: "Béta blokkoló hatásban"
    },
    [cardiopulmonaryStressTest_1.BetaBlocker.NO]: {
        id: "dashboard.cardiopulmonary_stress_test.beta_blocker.no",
        defaultMessage: "Nem volt béta blokkoló hatásban"
    }
};
function createCardiopulmonaryStressTest({ formatMessage, formatMessageMap }, { events }) {
    const ableToEvent = (0, events_1.findLastEventByQuery)(events, queries_1.queries.ableToSpiroergometry);
    if (ableToEvent === undefined) {
        return undefined;
    }
    if (ableToEvent.value === cardiopulmonaryStressTest_1.AbleToSpiroergometry.NO) {
        const { timestamp, sid, origin } = ableToEvent;
        return {
            type: "record",
            attachments: (0, events_1.mapEventsToAttachments)(ableToEvent),
            value: formatMessage(messages.notAbleToSpiroergometry),
            label: formatMessage(messages.cardiopulmonaryStressTest),
            timestamp,
            sid,
            origin
        };
    }
    const event = (0, events_1.findLastEventByQuery)(events, queries_1.queries.cardiopulmonaryStressTest);
    if (event === undefined) {
        return undefined;
    }
    const { value: { achievedMaxCapacity, vo2, betaBlocker }, timestamp, sid, origin } = event;
    const lines = [];
    lines.push(formatMessage(messages.vo2, { vo2 }));
    if (achievedMaxCapacity !== undefined) {
        lines.push(formatMessageMap(cardiopulmonaryStressTestAchievedMaxCapacityMessages, achievedMaxCapacity));
    }
    if (betaBlocker !== undefined) {
        lines.push(formatMessageMap(cardiopulmonaryStressTestBetaBlockerMessages, betaBlocker));
    }
    return {
        type: "record",
        alignment: "center",
        label: formatMessage(messages.cardiopulmonaryStressTest),
        attachments: (0, events_1.mapEventsToAttachments)(event),
        value: lines.join("\n"),
        timestamp,
        sid,
        origin
    };
}
